/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';
import 'jquery.cookie';
import wildcardDomain from '@/js/common/Domain/Service/wildcardDomain';
import AjaxRequestManager from '../AjaxRequestManager';
import CheckInDateRangeFactory from '../Factory/CheckInDateRange';
import CountryFactory from '../Factory/Country';
import TourCriteriaFacroty from '../Factory/TourCriteria';
import HotelsRepository from '../Repository/Hotels';
import CountriesRepository from '../Repository/Countries';
import DepartureCitiesRepository from '../Repository/DepartureCities';
import EntityManager from '../EntityManager';
import DepartureCityFactory from '../Factory/DepartureCity';

import CheckInDateRangeObjectValue from '../ObjectValue/CheckInDateRange';
//TODO: выпилить глобальную переменную, т.к это невозможно протестить (TF-1404: т.к блокер не переписал)
const ajaxRequestManager = new AjaxRequestManager({
    useCache: true,
});

const secure = document.location.protocol === 'https:';
const sameSite = secure ? '; SameSite=None' : '';

export default {
    loadTourCriteriaWithFormData(params, callback) {
        const setTourCriteria = params.setTourCriteria ? _.clone(params.setTourCriteria) : {};
        const referenceUrl = params.referenceUrl ? params.referenceUrl : false;
        const countriesRepository = params.countriesRepository ? params.countriesRepository : false;
        const dataType = params.dataType || 'jsonp';

        let setCheckInDateRange;
        const today = moment();

        if (setTourCriteria
            && setTourCriteria.checkInDateRange
            && setTourCriteria.checkInDateRange.from
            && setTourCriteria.checkInDateRange.to
        ) {
            setCheckInDateRange = CheckInDateRangeFactory(setTourCriteria.checkInDateRange, null, {
                disableOldDateCorrection: true,
            });

            if (!setCheckInDateRange
                || !setCheckInDateRange.get('from')
                || !setCheckInDateRange.get('to')
                || (moment(setCheckInDateRange.get('from')) < today && moment(setCheckInDateRange.get('to')) < today)
            ) {
                delete (setTourCriteria.checkInDateRange);
            }
        }

        const selectedDepartureCityId = window.appConfig?.defaultDepartureCityId || window.appConfig?.defaultTourCriteria?.departureCity || 2;
        const selectedCountryId = typeof (window.appConfig.defaultCountryId) !== 'undefined'
            ? window.appConfig.defaultCountryId
            : (typeof (window.appConfig.defaultTourCriteria) !== 'undefined' && window.appConfig.defaultTourCriteria.countries
                ? window.appConfig.defaultTourCriteria.countries[0]
                : null
            );

        this.getRemoteFormData({
                success(departureCities, countries) {
                    let tourCriteriaCountries = setTourCriteria && setTourCriteria.countries && setTourCriteria.countries.length
                        ? setTourCriteria.countries
                        : ((typeof selectedCountryId !== 'undefined' && selectedCountryId) ? [selectedCountryId] : null);

                    const defaultTourCriteriaCountryId = tourCriteriaCountries && tourCriteriaCountries.length
                        ? tourCriteriaCountries[0]
                        : null;

                    const tourCriteriaResorts = setTourCriteria && setTourCriteria.resorts && setTourCriteria.resorts.length
                        ? setTourCriteria.resorts
                        : (typeof defaultResorts !== 'undefined' ? defaultResorts : null);

                    let tourCriteriaDepartureCityId = setTourCriteria && setTourCriteria.departureCity
                        ? setTourCriteria.departureCity
                        : selectedDepartureCityId;

                    let defaultTourCriteria;
                    let tourCriteriaCountry;
                    let tourCriteriaDepartureCity;

                    const success = function () {
                        callback?.success
                            ? callback.success(new TourCriteriaFacroty(defaultTourCriteria, { defaultTourCriteria }))
                            : '';
                    };
                    const error = function () {
                        callback?.error
                            ? callback.error(new TourCriteriaFacroty(defaultTourCriteria, { defaultTourCriteria }))
                            : '';
                    };
                    const getHotels = function () {
                        HotelsRepository.repository.getHotels({
                            tourCriteria: defaultTourCriteria,
                            callback: {
                                success,
                                error,
                            },
                        });
                    };

                    if (defaultTourCriteriaCountryId && countries.get(defaultTourCriteriaCountryId)) {
                        tourCriteriaCountry = countries.get(defaultTourCriteriaCountryId);
                    } else {
                        tourCriteriaCountry = countries.min((country) => country.get('position'));
                        tourCriteriaCountries = [tourCriteriaCountry.get('id')];
                    }

                    if (tourCriteriaDepartureCityId && departureCities.get(tourCriteriaDepartureCityId)) {
                        tourCriteriaDepartureCity = departureCities.get(tourCriteriaDepartureCityId);
                    } else {
                        tourCriteriaDepartureCity = departureCities.get(selectedDepartureCityId);
                        tourCriteriaDepartureCityId = tourCriteriaDepartureCity.get('id');
                    }

                    const tourCriteriaType = tourCriteriaDepartureCity.get('type');

                    defaultTourCriteria = $.extend({}, tourCriteriaCountry.get(`${tourCriteriaType}TourCriteria`), setTourCriteria, {
                        departureCity: tourCriteriaDepartureCityId,
                        countries: tourCriteriaCountries,
                        resorts: tourCriteriaResorts || null,
                    });

                    if (!_.isEmpty(defaultTourCriteria.hotels)) {
                        tourCriteriaCountry.getResorts({
                            success: getHotels,
                            error: getHotels,
                        },
                        {
                            dataType,
                        });
                    } else {
                        tourCriteriaCountry.getResorts({
                            success,
                            error,
                        },
                        {
                            dataType,
                        });
                    }
                },
            },
            {
                referenceUrl,
                countriesRepository,
                dataType,
        });
    },
    getRemoteFormData(callback, params) {
        const referenceUrl = params && params.referenceUrl ? params && params.referenceUrl : false;
        const countriesRepository = params && params.countriesRepository ? params.countriesRepository : CountriesRepository.repository;
        const entityManager = new EntityManager();
        const url = window.appConfig?.getFormData
            ? (window.appConfig.gatewayUrl + (referenceUrl || window.appConfig.getFormData))
            : '';

        const options = {
            url,
            dataType: params?.dataType || 'jsonp',
            retriesAvailable: !!params?.dataType,
        };

        ajaxRequestManager.getData(options, {
            success(data) {
                const countries = _.map(data.destinationListPositions, (destinationListPosition) => {
                    const { country } = destinationListPosition;

                    $.extend(country, {
                        position: destinationListPosition.position,
                        isPopular: destinationListPosition.popular,
                        capitalTourCriteria: destinationListPosition.capitalTourCriteria,
                        regionTourCriteria: destinationListPosition.regionTourCriteria,
                    });
                    return country;
                });

                entityManager.add({
                    factory: CountryFactory,
                    repository: countriesRepository,
                }, countries, { merge: false });

                data.departureCities = _.sortBy(data.departureCities, (departureCity) => (departureCity.id <= 2 ? departureCity.id : departureCity.name));

                entityManager.add({
                    factory: DepartureCityFactory,
                    repository: DepartureCitiesRepository.repository,
                }, data.departureCities, { merge: false });

                DepartureCitiesRepository.repository.each((departureCity) => {
                    departureCity.set('countries', countriesRepository);
                });

                if (data.departureCities.length && countries.length) {
                    callback && callback.success ? callback.success(DepartureCitiesRepository.repository, countriesRepository) : '';
                } else {
                    //console.log(data);
                    console.log(options);
                    // TrackJS.track('No countries and departure cities returned!!');
                }
            },
            error(textStatus) {
                callback && callback.error ? callback.error() : '';
            },
        });
    },
    addTourCriteriaChangedField(fieldName) {
        let changedFields = [];
        const changedFieldsFromCookie = $.cookie('tourCriteriaChanged');

        if (changedFieldsFromCookie && changedFieldsFromCookie !== '') {
            changedFields = changedFieldsFromCookie.split('.');
        }

        if (_.indexOf(changedFields, fieldName) === -1) {
            changedFields.push(fieldName);
        }

        $.cookie('tourCriteriaChanged', changedFields.join('.'), { path: `/${sameSite}`, domain: wildcardDomain(), secure });
    },
    getTourCriteriaChangedFields() {
        let changedFields = [];
        const changedFieldsFromCookie = $.cookie('tourCriteriaChanged');

        if (changedFieldsFromCookie && changedFieldsFromCookie !== '') {
            changedFields = changedFieldsFromCookie.split('.');
        }

        return changedFields;
    },
    getMaybeWrongFields(tourCriteria) {
        let difference = [];
        const country = tourCriteria.get('countries');
        const departureCity = tourCriteria.get('departureCity');
        const departureCityType = departureCity ? departureCity.get('type') : null;
        let countryTourCriteria = country && country.at(0) ? (departureCityType ? country.at(0).get(`${departureCityType}TourCriteria`) : country.at(0).get('tourCriteria')) : null;
        let element;
        let criteriaPriority;

        let currentDate;

        countryTourCriteria = _.clone(countryTourCriteria);

        if (countryTourCriteria) {
            if (typeof (window.appConfig.defaultTourCriteria) !== 'undefined' && window.appConfig.defaultTourCriteria.checkInDateRange) {
                countryTourCriteria.checkInDateRange = new CheckInDateRangeFactory(window.appConfig.defaultTourCriteria.checkInDateRange);
            }

            if (typeof (window.appConfig.defaultTourCriteria) !== 'undefined' && window.appConfig.defaultTourCriteria.priceRange) {
                countryTourCriteria.priceRange = window.appConfig.defaultTourCriteria.priceRange;
            }

            if (countryTourCriteria.checkInDateRange && !(countryTourCriteria.checkInDateRange instanceof CheckInDateRangeObjectValue)) {
                countryTourCriteria.checkInDateRange = new CheckInDateRangeFactory(countryTourCriteria.checkInDateRange);
            }

            element = tourCriteria.get('priceRange');
            if (element !== null) {
                element.get('from') > countryTourCriteria.priceRange.from || element.get('to') < countryTourCriteria.priceRange.to ? difference.push({
                    name: 'priceRange',
                    priority: 1,
                }) : null;
            }

            element = tourCriteria.get('hotelCategories');
            if (element !== null && element.length) {
                _.intersection(element.pluck('id'), countryTourCriteria.hotelCategories).length !== countryTourCriteria.hotelCategories.length ? difference.push({
                    name: 'hotelCategories',
                    priority: 2,
                }) : null;
                countryTourCriteria.hotelCategories.length === 0 ? difference.push({
                    name: 'hotelCategories',
                    priority: 2,
                }) : null;
            }

            element = tourCriteria.get('meals');
            if (element !== null && element.length) {
                _.intersection(element.pluck('id'), countryTourCriteria.meals).length !== countryTourCriteria.meals.length ? difference.push({
                    name: 'meals',
                    priority: 3,
                }) : null;
                countryTourCriteria.meals.length === 0 ? difference.push({ name: 'meals', priority: 3 }) : null;
            }

            element = tourCriteria.get('hotels');
            if (element !== null && element.length) {
                difference.push({ name: 'hotels', priority: 4 });
            }

            element = tourCriteria.get('resorts');
            if (element !== null && element.length) {
                difference.push({ name: 'resorts', priority: 5 });
            }

            element = tourCriteria.get('checkInDateRange');
            if (element !== null && countryTourCriteria.checkInDateRange) {
                currentDate = new Date();

                if (element.get('from').getTime() - currentDate.getTime() > 15811200000/*half of year*/) {
                    criteriaPriority = 1.5;
                } else {
                    criteriaPriority = 6;
                }

                if (element.get('from').getTime() > countryTourCriteria.checkInDateRange.get('from').getTime() || element.get('to').getTime() < countryTourCriteria.checkInDateRange.get('to').getTime()) {
                    difference.push({ name: 'checkInDateRange', priority: criteriaPriority });
                }
            }

            element = tourCriteria.get('nightRange');
            if (element !== null) {
                element.get('from') > countryTourCriteria.nightRange.from || element.get('to') < countryTourCriteria.nightRange.to ? difference.push({
                    name: 'nightRange',
                    priority: 7,
                }) : null;
            }

            difference = _.chain(difference)
                .sortBy((field) => field.priority)
                .map((field) => field.name).value();
        }

        /* hack for ski page*/
        if (window.appConfig.isSki) {
            difference = _.without(difference, 'nightRange');
        }

        return difference;
    },
    clearTourCriteriaChangedFields() {
        $.cookie('tourCriteriaChanged', '', { path: `/${sameSite}`, domain: wildcardDomain(), secure });
    },
};
